import React from 'react';

import {VersionsSidebarFactory} from 'app/components/general/VersionsSidebar';
import {InfiniteListRTK} from 'app/general/datafetchers/InfiniteListRTK';
import {
  convertLocationParamsToFetchParams,
  useQuizVersions,
} from 'app/quizzes/api';
import {SORT_BY_TYPES} from 'app/utils/constants';

import type {SpecificVersionsSidebarOwnProps} from 'app/components/general/VersionsSidebar';
import type {QuizVersionSerializedType} from 'sweet-types';

export const QuizVersionsSidebar = ({
  object,
  selectedVersion,
}: SpecificVersionsSidebarOwnProps) => {
  return (
    <InfiniteListRTK
      fetchParams={{
        quizId: object.id,
        ordering: SORT_BY_TYPES.CREATION_DATE,
      }}
      useDataHook={useQuizVersions}
      paramsConverter={convertLocationParamsToFetchParams}
    >
      {({results: versions, refetch, loadNext, hasNext}) => (
        <VersionsSidebarComponent
          object={object}
          selectedVersion={selectedVersion}
          loadVersions={async () => refetch()}
          loadMoreVersions={async () => loadNext()}
          moreToLoad={hasNext}
          versions={versions}
        />
      )}
    </InfiniteListRTK>
  );
};

const VersionsSidebarComponent =
  VersionsSidebarFactory<QuizVersionSerializedType>();
